module.exports = __webpack_public_path__ + "static/media/Celebraciones-para-empresas- 1.e8ccd5b5.JPG";